import styled from 'styled-components';
import { Fonts } from '../../config/theme';

const Wrapper = styled.div`
  .Silal-library {
    background: #ffffff;
    border: 0.5px solid rgba(0, 0, 0, 0.04);
    box-shadow:
      0px 3px 8px rgba(0, 0, 0, 0.12),
      0px 3px 1px rgba(0, 0, 0, 0.04);
    border-radius: 6.93px;
  }
  .Silal-library-div {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .searchContainer {
    margin-top: 23px;
    display: grid;
    grid-template-columns: 11fr 2fr;
    column-gap: 20px;
    align-items: center;
    button {
      border: none;
      background: var(--app-color-dark);
      font-size: 15px;
      font-weight: 500;
      border: 1px solid rgba(232, 232, 232, 0.5);
      border-radius: 5px;
      color: white;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      transition: 0.3s ease;
      :hover {
        background: var(--app-color-dark);
        color: var(--color-light);
      }
      svg {
        margin-right: 5px;
        width: 24px;
        height: 24px;
      }
    }
    .search {
      background: var(--app-color-dark);
      color: var(--color-light);
      font-size: 15px;
      font-weight: 600;
      :hover {
        color: var(--app-color-dark);
        background: var(--color-light);
        border: 1px solid var(--app-color-dark);
      }
    }
  }
  .card-header {
    width: 100%;
    background: var(--app-color-dark);
    padding: 15px;
    color: var(--color-light);
    display: flex;
    align-items: center;
    justify-content: space-between;
    .customer-rating {
      display: flex;
      gap: 3px;
    }
    .rating {
      font-family: ${Fonts.secondary};
      font-style: normal;
      font-weight: 600;
      font-size: 11px;
    }
    .total-stars {
      font-family: ${Fonts.secondary};
      font-style: normal;
      font-weight: 600;
      font-size: 11px;
      color: var(--color-light-gray);
    }
    h4 {
      font-size: 15px;
      font-weight: 600;
    }
    button {
      padding: 5px 8px;
      background: rgba(255, 255, 255, 0.3);
      border-radius: 5px;
      border: none;
      outline: none;
      font-size: 11px;
      font-weight: 500;
      color: var(--color-light);
      margin-top: 10px;
    }
  }

  .grid-row.blurr {
    opacity: 0.2;
  }

  .top-row {
    display: grid;
    grid-template-columns: 6fr 1fr;
    grid-gap: 15px;
    button {
      border: 1px solid transparent;
      transition: 0.3 ease;
      :hover {
        background: transparent;
        color: var(--app-color-dark);
        border: 1px solid var(--app-color-dark);
      }
    }
  }
  .eye-desghn {
    display: flex;
    justify-content: space-between;
  }
  .grid-row {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 20px;
    margin-bottom: 40px;
    .gird-column {
      padding: 15px;
      background: var(--color-light);
      border-radius: 5px;
      box-shadow: 0px 5px 10px -2px rgba(196, 214, 220, 0.25);
      position: relative;
      color: #ccd4d6;
      transition: 0.3s ease;
      :hover {
        cursor: pointer;
        /* background: #e0e6e7; */
      }
      .icon {
        margin-bottom: 31px;
        text-align: right;
      }
      .body {
        h4 {
          font-size: 17px;
          font-weight: 600;
          line-height: 2.2;
          color: var(--color-dark);
        }
        p {
          font-size: 13px;
          font-weight: 600;
          line-height: 1.6;
        }
      }
      .overlay {
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
      }
    }
  }

  .dropdown_ul {
    position: absolute;
    top: 28px;
    right: 23px;
    border-radius: 5px;
    font-family: ${Fonts.primary}, sans-serif;
    list-style: none;
    font-size: 15px;
    box-shadow: 1px 1px 1px 1px #ccd4d6;
    z-index: 9999999;
    li {
      padding: 10px 20px;
      color: var(--color-dark);
      background: var(--color-light);
      :hover {
        background: #f2f4f5;
      }
    }
  }
  .alts-logo {
    background-color: var(--color-warn);
    width: 21px;
    height: 19px;
    display: flex;
    justify-content: center;
    align-items: center;

    border-radius: 11px;
    p {
      color: white;
      margin: 6px;
    }
  }
  .alts-Box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 5px;
  }
  .alts-Boxs {
    display: flex;
    justify-content: end;
    align-items: center;
    margin: 5px;
  }
  .load-more {
    margin-bottom: 50px;
  }
  .float-submit {
    position: fixed;
    bottom: 20px;
    width: 100%;
    height: 60px;
    z-index: 9999;
    right: 0px;
    padding: 10px 30px;
    button {
      width: 70% !important;
    }
  }
`;
export default Wrapper;
